module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "font-size": "53px",
      "color": "#999",
      "text-align": "center",
      "padding-top": "40px"
    }
  }, [_vm._v("Freshin")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "27px",
      "color": "#666",
      "text-align": "center"
    }
  }, [_vm._v("修改密码")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('a-form', [_c('div', {
    staticStyle: {
      "text-align": "left",
      "width": "500px",
      "display": "inline-block"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('a-form-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "has-feedback": _vm.passwordstate,
      "label": "新登录密码",
      "validate-status": _vm.passwordtext,
      "help": "登录密码必须是6-20位字母和数字组成"
    }
  }, [_c('a-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "350px"
    },
    attrs: {
      "size": "large",
      "placeholder": "请输入新登录密码",
      "type": "password"
    },
    on: {
      "change": _vm.passwordchange
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('a-form-item', {
    attrs: {
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol,
      "has-feedback": _vm.repasswordstate,
      "label": "确认新登录密码",
      "validate-status": _vm.repasswordtext,
      "help": "必须和上面密码保持一致"
    }
  }, [_c('a-input', {
    staticStyle: {
      "display": "inline-block",
      "width": "350px"
    },
    attrs: {
      "size": "large",
      "placeholder": "请输入新登录密码",
      "type": "password"
    },
    on: {
      "change": _vm.repasswordchange
    },
    model: {
      value: (_vm.repassword),
      callback: function($$v) {
        _vm.repassword = $$v
      },
      expression: "repassword"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-button', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.verification
    }
  }, [_vm._v("确认")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "bottom": "30px",
      "text-align": "center",
      "width": "100%",
      "font-size": "12px"
    }
  }, [_vm._v("powered by Freshin")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23faccdc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/repassword/index.vue
// module id = 2369
// module chunks = 1